import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import styles from './styles.module.scss'
import { appConstantSettings } from 'srcReact/appConstantSettings'
import Header from 'srcReact/GroupHomePage/components/Header'
import Mixrs from 'srcReact/GroupHomePage/components/Mixrs'
import Info from 'srcReact/GroupHomePage/components/Info'
import Media from 'srcReact/GroupHomePage/components/Media'
import Members from 'srcReact/GroupHomePage/components/Members'
import DeleteGroupPopin from 'srcReact/components/popinsContent/DeleteGroupPopin'
import Tabs from 'srcReact/components/common2/Tabs'
import PageContainer from 'srcReact/PageContainer/PageContainer'
import ReactMenu from 'srcReact/components/common2/ReactMenu'
import Icon from 'srcReact/components/icons/Icon'
import history, { redirectToPage, historyReplaceState, redirectToBack } from 'srcReact/helpers/history'
import { groupHomeActions } from 'srcReact/GroupHomePage'
import PendingActions from './components/PendingActions'
import Feeds from './components/Feeds'
import queryString from 'query-string'
import { isMobileScreen, urlSearchParams, getFlaggedColor } from 'srcReact/helpers/utils'
import MemberOverview from 'srcReact/components/common2/MemberOverview'
import NavigationMobile from './components/NavigationMobile'
import { alertActions, AlertContainer } from 'srcReact/Alert'
import { commonActions } from 'srcReact/components'
import Loader from 'srcReact/components/common2/Loader'
import { moderationReportActions } from 'srcReact/ModerationReportPage'
import SuspendSection from 'srcReact/components/common2/SuspendSection'
import BackNavigation from 'srcReact/components/common2/BackNavigation'
import Widgets from './components/Widgets'
import Modal from 'srcReact/components/common2/Modal'
import CreatedSuggestedMixrPopin from 'srcReact/components/popinsContent/CreatedSuggestedMixrPopin'
import SuspendModal from 'srcReact/ModerationReportPage/components/SuspendModal'
import { getCurrentOrgId } from 'srcReact/helpers/organizationHelper'
import { isWorkplaceManager } from 'srcReact/helpers/workplaceHelper'
import ReviewActionButton from 'srcReact/components/common2/ReviewActionButton'
import Invitation from './components/Invitation'

const GroupHomePageContainer = (props) => {
  const { t } = useTranslation()

  const dispatch = useDispatch()
  const {
    alert,
    login: { user: loggedInUser },
    common: { isNative, isDesktop, isMobile },
    groupHome: {
      group,
      refreshGroup,
      groupLoading,
      stats,
      activeMembers,
      activeMembersStats,
      staff,
      groupOrganizer,
      moderation_info,
      widgets,
      future_mixrs,
      past_mixrs
    }
  } = useSelector((state) => state)
  const [groupId, setGroupId] = useState(props.match.params.groupId)
  const [totalActiveMemberCount, setTotalActiveMemberCount] = useState(0)
  const [initialActive, setInitialActive] = useState(0)
  const [showGroupDeleteModal, setShowGroupDeleteModal] = useState(false)
  // const [isMobile, setIsMobile] = useState(isMobileScreen())
  // const [isDesktop, setIsDesktop] = useState(isWideScreen())
  const [selectedTabFromUrl, setSelectedTabFromUrl] = useState('')
  const [feedIdToScroll, setFeedIdToScroll] = useState(0)
  const [scrollToTab, setScrollToTab] = useState(false)
  const [dateForMixrs, setDateForMixrs] = useState('')
  const [showSuggestedMixrPopup, setShowSuggestedMixrPopup] = useState(false)
  const [isWidgetsExpanded, setIsWidgetsExpanded] = useState(true)
  const [mediaScope, setMediaScope] = useState('pictures_media')
  const [mediaWidgetMoreClicked, setMediaWidgetMoreClicked] = useState(false)
  const [isBackButton, setIsBackButton] = useState(
    (history.location.state && history.location.state.backNavigation) || false
  )
  const [isSuspendModalOpen, setIsSuspendModalOpen] = useState(false)

  // Get flag reasons
  useEffect(() => {
    dispatch(moderationReportActions.getFlagReasons())
  }, [])
  useEffect(() => {
    if (props.match.params.groupId !== groupId) {
      setGroupId(props.match.params.groupId)
    }
  }, [props.match.params.groupId])
  // useEffect(() => {
  //   if (groupId) {
  //     dispatch(commonActions.addUserPageView(appConstantSettings.GROUP_PAGE, groupId))
  //   }
  // }, [groupId])
  useEffect(() => {
    if (groupId) {
      let scopes = 'active_members,staff_members,stats,organizer'
      dispatch(groupHomeActions.getGroupHomeGroupInfo(groupId, scopes, 'feed'))
    }
  }, [groupId, refreshGroup])
  useEffect(() => {
    if (group.error) {
      redirectToPage(`/0/${appConstantSettings.DEFAULT_HOMEPAGE}`, isNative)
      dispatch(groupHomeActions.resetAction('GROUPHOME_GROUP_INFO'))
    }
  }, [group.error])
  useEffect(() => {
    //this code will be executed when user clicks on "more arrow" on member overview component
    //it is to focus members on screen
    if (scrollToTab) {
      setTimeout(() => {
        if (isNative || isMobile) {
          window.scrollTo(0, 300)
        } else {
          window.scrollTo(0, 320)
        }
      }, 0)
      setScrollToTab(false)
    }
  }, [activeMembers])
  useEffect(() => {
    if (activeMembersStats) {
      setTotalActiveMemberCount(activeMembersStats.total)
    }
  }, [activeMembersStats])
  useEffect(() => {
    window.scrollTo(0, 0)

    let locationObj = queryString.parse(location.search)

    if (locationObj) {
      if (locationObj.feed) {
        const feedId = locationObj.feed
        if (feedId && feedId > 0) {
          setFeedIdToScroll(feedId)
          if (isMobileScreen()) {
            redirectToPage(`/0/feed-content/group/${groupId}/${feedId}`, isNative)
          }
        }
      } else {
        dispatch(commonActions.addUserPageView(appConstantSettings.GROUP_PAGE, groupId))
      }
      if (locationObj.type === 'suggested') {
        setShowSuggestedMixrPopup(true)
      }
    } else {
      dispatch(commonActions.addUserPageView(appConstantSettings.GROUP_PAGE, groupId))
    }
    const path = props && props.location ? props.location.pathname : null
    if (path) {
      const pathArr = path.split('/')
      const tab = pathArr.pop()
      if (tab === 'leadership') {
        setInitialActive(2)
        setSelectedTabFromUrl(tab)
        setIsBackButton(true)
      } else if (tab === 'participants') {
        setInitialActive(2)
        setIsBackButton(true)
      } else if (tab === 'media') {
        setInitialActive(3)
        setIsBackButton(true)
      } else if (tab === 'info') {
        setInitialActive(4)
        setIsBackButton(true)
      } else if (tab === 'feed') {
        setInitialActive(0)
        setIsBackButton(true)
      } else if (tab === 'mixrs') {
        setInitialActive(1)
        setIsBackButton(true)
      }
    }

    // nativeapp
    if (isNative) {
      const lastActiveTab = localStorage.getItem('lastActiveTab')
      if (lastActiveTab) setInitialActive(lastActiveTab)
    }

    return () => {
      dispatch(groupHomeActions.setInitialState())
    }
  }, [])

  const closeSuggestedMixrPopup = () => {
    setShowSuggestedMixrPopup(false)
  }

  const selectTab = (tabName, subTabName) => {
    if (isNative || isMobile) {
      window.scrollTo(0, 300)
    } else {
      window.scrollTo(0, 320)
    }
    if (tabName === 'leadership') {
      setInitialActive(2)
    } else if (tabName === 'participants') {
      setInitialActive(2)
    } else if (tabName === 'media') {
      setInitialActive(3)
      if (subTabName) {
        setMediaWidgetMoreClicked(true)
        setMediaScope(subTabName)
        setTimeout(() => setMediaWidgetMoreClicked(false), 500)
      }
    } else if (tabName === 'info') {
      setInitialActive(4)
    } else if (tabName === 'feed') {
      setInitialActive(0)
    } else if (tabName === 'mixrs') {
      setInitialActive(1)
    }
  }

  useEffect(() => {
    history.listen((location) => {
      const pathname = location.pathname
      const param = pathname.split('/').pop()
      if (param && param.startsWith('mixrs-on-')) {
        setInitialActive(1)
        setIsBackButton(true)
        setDateForMixrs(+param.split('-').pop())
      } else {
        setDateForMixrs('')
      }
    })
  }, [history])

  const isPrivateGroup = group.privacy_setting !== 'public'
  const isMemberOfGroup = group.logged_user.group_role !== 'none'
  const isGroupOrganizer =
    group.logged_user.group_role === 'organizer' || group.logged_user.group_role === 'co-organizer'
  const joinAutoApprove = group.automatic_approval_to_join === 1
  const hasMemberRole = group.logged_user.group_role === 'member'
  const groupAttendPending = group.logged_user.group_attending === 'pending'
  const selectParticipantsTab = () => {
    setScrollToTab(true)
    setInitialActive(2)
  }
  const handleOrgDashboard = () => {
    redirectToPage(`/0/dashboard/group/${group.id}`, isNative)
  }
  const handleCoOrgDashboard = () => {
    redirectToPage(`/0/dashboard/group/${group.id}`, isNative)
  }
  const handleOrgPlanMixr = () => {
    redirectToPage(`/0/${group.id}/create-mixr`, isNative)
  }
  const handleOrgEditGroup = () => {
    redirectToPage(`/0/edit-group/${group.id}`, isNative)
  }
  const handleCoOrgEditGroup = () => {
    redirectToPage(`/0/edit-group/${group.id}`, isNative)
  }
  const handleMemberShare = () => {
    redirectToPage(`/0/group/${group.id}/invite-members`, isNative)
  }
  const threeDotsOptions = () => {
    switch (group.logged_user.group_role) {
      case 'organizer':
        let organizer = []
        organizer.push({
          text: t('groupHome.options.invite'),
          onClick: handleMemberShare
        })
        organizer.push({
          text: t('groupHome.options.dashboard'),
          onClick: handleOrgDashboard
        })
        organizer.push({
          text: t('global.planMixr'),
          onClick: handleOrgPlanMixr
        })
        organizer.push({
          text: t('groupHome.options.editGroup'),
          onClick: handleOrgEditGroup
        })
        organizer.push({
          text: t('groupHome.options.manageMembers'),
          onClick: () => setInitialActive(2)
        })
        if (group.is_general != 1) {
          organizer.push({
            text: t('groupHome.options.deleteGroup'),
            onClick: () => setShowGroupDeleteModal(!showGroupDeleteModal)
          })
        }
        return organizer
      case 'co-organizer':
        let coorganizer = []
        coorganizer.push({
          text: t('groupHome.options.invite'),
          onClick: handleMemberShare
        })
        coorganizer.push({
          text: t('groupHome.options.dashboard'),
          onClick: handleCoOrgDashboard
        })
        coorganizer.push({
          text: t('global.planMixr'),
          onClick: () => (window.location = `/0/${group.id}/create-mixr`)
        })
        coorganizer.push({
          text: t('groupHome.options.editGroup'),
          onClick: handleCoOrgEditGroup
        })
        coorganizer.push({
          text: t('groupHome.options.manageMembers'),
          onClick: () => setInitialActive(2)
        })
        if (group.is_general != 1) {
          coorganizer.push({
            text: t('groupHome.options.leaveGroup'),
            onClick: () => dispatch(groupHomeActions.removeMemberFromGroup(group.id))
          })
        }
        return coorganizer
      case 'member':
        let member = []
        member.push({
          text: t('groupHome.options.invite'),
          onClick: handleMemberShare
        })
        member.push({
          text: t('global.suggestMixr'),
          onClick: () => (window.location = `/0/${group.id}/create-mixr`)
        })
        if (group.is_general != 1) {
          member.push({
            text: t('groupHome.options.leaveGroup'),
            onClick: () => dispatch(groupHomeActions.removeMemberFromGroup(group.id))
          })
        }
        if (isWorkplaceManager()) {
          //1206158840299382-If the group or mixr is created by one of workplace managers himself, display option "suspend" only for Organization admin
          //Do not display this option for workplace managers
          if (
            group.organizer.is_workplace_manager === 0 ||
            (group.organizer.is_workplace_manager === 1 && group.logged_user.is_organization_admin === 1)
          ) {
            member.push({
              text: t('moderationReport.flagPost.suspend'),
              onClick: () => setIsSuspendModalOpen(true)
            })
          }
        }
        return member
      case 'none':
        let none = []
        if (group.automatic_approval_to_join == 1) {
          none.push({
            text: t('groupHome.options.joinGroup'),
            onClick: () => dispatch(groupHomeActions.addMemberToGroup(group.id))
          })
        } else if (group.automatic_approval_to_join == 0) {
          if (group.logged_user.invited_by === 'staffMember') {
            none.push({
              text: t('global.acceptInvitation'),
              onClick: () => dispatch(groupHomeActions.acceptInvitation(group.id))
            })
          } else if (group.logged_user.group_attending !== 'pending') {
            none.push({
              text: t('groupHome.options.requestJoin'),
              onClick: () => dispatch(groupHomeActions.addMemberToGroup(group.id))
            })
          }
        }
        if (!isPrivateGroup) {
          none.push({
            text: t('groupHome.options.invite'),
            onClick: handleMemberShare
          })
        }
        if (isWorkplaceManager()) {
          //1206158840299382-If the group or mixr is created by one of workplace managers himself, display option "suspend" only for Organization admin
          //Do not display this option for workplace managers
          if (
            group.organizer.is_workplace_manager === 0 ||
            (group.organizer.is_workplace_manager === 1 && group.logged_user.is_organization_admin === 1)
          ) {
            none.push({
              text: t('moderationReport.flagPost.suspend'),
              onClick: () => setIsSuspendModalOpen(true)
            })
          }
        }
        return none
      default:
        return []
    }
  }
  const renderShareButton = () => {
    if (!isPrivateGroup) {
      return (
        <button role='button' onClick={handleMemberShare} className={styles.actionBtn}>
          <Icon name='send' styleModifier={styles.inviteIcon} /> {t('groupHome.header.invite')}
        </button>
      )
    }
  }
  const acceptInvitation = () => {
    if (group) {
      dispatch(groupHomeActions.acceptInvitation(group.id))
    }
  }
  const handleReinstate = () => {
    dispatch(moderationReportActions.reinstate('group', groupId))
  }
  const handleSuspend = (message) => {
    const orgId = getCurrentOrgId()
    if (moderation_info && moderation_info.moderation_id) {
      dispatch(moderationReportActions.suspend(moderation_info.moderation_id, orgId, message, group.id))
      redirectToBack(isNative)
    }
  }
  const hideSuspendModal = () => {
    setIsSuspendModalOpen(false)
  }
  const tabRightContent = (
    <div
      className={`${styles.tabRightContent} ${
        moderation_info && moderation_info.is_suspended && 'elementWithSuspendedObject'
      }`}>
      {isDesktop && (
        <React.Fragment>
          {(group.logged_user.group_role === 'organizer' || group.logged_user.group_role === 'co-organizer') && (
            <React.Fragment>
              <button role='button' onClick={handleMemberShare} className={styles.actionBtn}>
                <Icon name='send' styleModifier={styles.inviteIcon} /> {t('groupHome.header.invite')}
              </button>
              <button
                role='button'
                onClick={() => redirectToPage(`/0/${group.id}/create-mixr`, isNative)}
                className={styles.actionBtn}>
                <Icon name='add-to-cal' styleModifier={styles.calendarIcon} /> {t('global.planMixr')}
              </button>
            </React.Fragment>
          )}
          {group.logged_user.group_role === 'member' && (
            <React.Fragment>
              {renderShareButton()}
              <button
                role='button'
                onClick={() => (window.location = `/0/${group.id}/create-mixr`)}
                className={`${styles.actionBtn} ${styles.actionMixrBtnLong}`}>
                <Icon name='calendar24' styleModifier={styles.calendarIcon} /> {t('global.suggestMixr')}
              </button>
            </React.Fragment>
          )}
          {group.logged_user.group_role === 'none' && group.automatic_approval_to_join == 1 && (
            <React.Fragment>
              {renderShareButton()}
              <button
                role='button'
                onClick={() => {
                  dispatch(groupHomeActions.addMemberToGroup(group.id))
                }}
                className={`${styles.actionBtn} ${styles.maxWidth}`}>
                {t('groupHome.header.joinGroup')}
              </button>
            </React.Fragment>
          )}

          {group.logged_user.group_role === 'none' && group.automatic_approval_to_join == 0 ? (
            group.logged_user.invited_by === 'staffMember' ? (
              <React.Fragment>
                {renderShareButton()}
                <button
                  role='button'
                  onClick={acceptInvitation}
                  className={`${styles.actionBtn} ${styles.actionMixrBtnLong}`}>
                  {t('global.acceptInvitation')}
                </button>
              </React.Fragment>
            ) : (
              <React.Fragment>
                {renderShareButton()}
                {group.logged_user.group_attending !== 'pending' ? (
                  <button
                    role='button'
                    onClick={() => dispatch(groupHomeActions.addMemberToGroup(group.id))}
                    className={`${styles.actionBtn} ${styles.actionMixrBtnLong}`}>
                    {t('groupHome.header.requestJoin')}
                  </button>
                ) : (
                  <div className={`${styles.actionBtn} ${styles.pendingRequestBtn} ${styles.actionMixrBtnLong}`}>
                    {t('groupHome.header.pendingRequest')}
                  </div>
                )}
              </React.Fragment>
            )
          ) : null}
        </React.Fragment>
      )}
      <ReactMenu options={threeDotsOptions()} menuButtonCSS={styles.menuButtonCSS} menuCSS={styles.menuCSS} />
    </div>
  )
  const addMemberToGroup = () => {
    dispatch(groupHomeActions.addMemberToGroup(group.id))
  }
  const handleActiveTab = (active, tabName) => {
    dispatch(groupHomeActions.getGroupWidgetScope(groupId, tabName))
    setInitialActive(active)
    localStorage.setItem('lastActiveTab', active)
    historyReplaceState(`/0/home/group/${groupId}/${tabName}`)
  }

  const handleAddCoorganizer = (userId) => {
    if (group) {
      dispatch(groupHomeActions.addStaffRole(groupId, userId, 'co-organizer'))
    }
  }
  const handleRemoveCoorganizer = (userId) => {
    if (group) {
      dispatch(groupHomeActions.removeStaffRole(groupId, userId, 'staff_members'))
    }
  }
  const handleRemoveFromGroup = (userId) => {
    if (group) {
      dispatch(groupHomeActions.removeFromGroup(groupId, userId))
    }
  }
  const renderMemberOverview = () => {
    return (
      <MemberOverview
        className={`${isDesktop ? styles.membersOverview : styles.membersOverviewMobile} ${
          moderation_info && moderation_info.is_suspended && 'elementWithSuspendedObject'
        }`}
        participants={activeMembers}
        organizers={!isMemberOfGroup && isPrivateGroup ? [groupOrganizer] : staff}
        totalUserCount={!isMemberOfGroup && isPrivateGroup ? 1 : totalActiveMemberCount}
        selectParticipantsTab={selectParticipantsTab}
        handleAddCoorganizer={handleAddCoorganizer}
        handleRemoveCoorganizer={handleRemoveCoorganizer}
        handleRemoveFromGroup={handleRemoveFromGroup}
        type='group'
        isStaffMember={isGroupOrganizer}
      />
    )
  }

  if (group.loading && groupLoading) {
    return (
      <PageContainer pageTitle={t('global.group')} withFooter={false}>
        <div className={styles.loading}>
          <Loader />
        </div>
      </PageContainer>
    )
  }

  const handleWidgetToggle = (isExpanded) => {
    setIsWidgetsExpanded(isExpanded)
  }

  const handleBack = () => {
    const isBackInUrl = history.location.pathname.includes('backNavigation')
    if (isBackButton || isBackInUrl) {
      redirectToBack(isNative)
    } else {
      redirectToPage(`/0/myhome`, isNative)
    }
  }

  return (
    <PageContainer
      pageTitle={t('groupHome.pageTitle', { groupName: group.name })}
      pageClassName={styles.mainPage}
      withFooter={false}
      withSidebar={true}
      hasWidgets={true}
      onWidgetToggle={handleWidgetToggle}
      renderWidgets={() => {
        if (group) {
          return (
            <Widgets
              tab={
                initialActive == 0
                  ? 'feed'
                  : initialActive == 1
                  ? 'mixrs'
                  : initialActive == 2
                  ? 'members'
                  : initialActive == 3
                  ? 'media'
                  : initialActive == 4
                  ? 'info'
                  : ''
              }
              groupId={groupId}
              widgets={widgets}
              mixrs={[...past_mixrs.mixrs, ...future_mixrs.mixrs]}
              selectTab={selectTab}
              loggedInUser={loggedInUser}
              isStaffMember={isGroupOrganizer}
              handleAddCoorganizer={handleAddCoorganizer}
              handleRemoveCoorganizer={handleRemoveCoorganizer}
              handleRemoveFromGroup={handleRemoveFromGroup}
            />
          )
        }
      }}>
      {alert && alert.message ? (
        <AlertContainer
          title={t('error.error_alert_title')}
          message={alert.message}
          show={!!alert.message}
          handleClose={() => dispatch(alertActions.clear())}
        />
      ) : null}
      <div
        className={`${styles.outerWrapper} ${isNative && styles.nativeOuterWrapper} ${
          isWidgetsExpanded && styles.outerWrapperWidgetExpanded
        }`}>
        <div id='home_wrapper' className={`${styles.groupWrapper} ${isNative && styles.nativeGroupWrapper}`}>
          {group?.logged_user?.invitations?.length > 0 && (
            <Invitation
              groupId={group.id}
              invitation={group.logged_user.invitations[0]}
              isPrivateGroup={group.privacy_setting === 'private'}
              isAutoApproveToJoin={group.automatic_approval_to_join}
              isInPendingState={group.logged_user.group_attending === 'pending'}
            />
          )}
          {isDesktop ? (
            <React.Fragment>
              <div className={styles.membersAndBackWrapper}>
                <BackNavigation className={styles.backWrapper} customHandleBack={handleBack} />
                {renderMemberOverview()}
              </div>
              {moderation_info && moderation_info.is_suspended && (
                <SuspendSection
                  objectType='group'
                  status={moderation_info.suspention_status}
                  handleReinstate={handleReinstate}
                  handleEdit={handleOrgEditGroup}
                  instruction={moderation_info.suspension_message}
                  handleDelete={() => setShowGroupDeleteModal(!showGroupDeleteModal)}
                />
              )}
            </React.Fragment>
          ) : (
            <NavigationMobile
              groupId={groupId}
              isMemberOfGroup={isMemberOfGroup} //role is anything but "none" (member/co-organizer/organizer)
              isGroupOrganizer={isGroupOrganizer}
              isNative={isNative}
              joinAutoApprove={joinAutoApprove}
              hasMemberRole={hasMemberRole} //role is exactly  "member"
              groupAttendPending={groupAttendPending}
              isInvite={group?.logged_user?.invited_by != false}
              isInvitedByStaff={group ? group.logged_user.invited_by === 'staffMember' : false}
              handleMemberShare={handleMemberShare}
              addMemberToGroup={addMemberToGroup}
              threeDotsOptions={threeDotsOptions}
              acceptInvitation={acceptInvitation}
              isSuspended={moderation_info && moderation_info.is_suspended}
              customHandleBack={handleBack}
            />
          )}
          {!isDesktop && renderMemberOverview()}
          {moderation_info ? (
            moderation_info.is_suspended && !isDesktop ? (
              <SuspendSection
                objectType='group'
                objectId={groupId}
                status={moderation_info.suspention_status}
                instruction={moderation_info.suspension_message}
                handleReinstate={handleReinstate}
                handleEdit={handleOrgEditGroup}
                handleDelete={() => setShowGroupDeleteModal(!showGroupDeleteModal)}
              />
            ) : moderation_info.flagged_posts >= 1 ? (
              <ReviewActionButton
                iconName='flag-icon'
                text={t('moderationReport.flaggedContentItem', {
                  count: moderation_info.flagged_posts,
                  item: moderation_info.flagged_posts > 1 ? t('moderationReport.items') : t('moderationReport.item')
                })}
                color={getFlaggedColor(moderation_info.flagged_posts)}
                handleClick={() => redirectToPage(`/0/moderation?tab=awaiting_review`, isNative)}
              />
            ) : null
          ) : null}
          <Header groupId={groupId} isDesktop={isDesktop} />
          <Tabs
            initialActive={initialActive}
            className={`${styles.tabs} ${
              moderation_info && moderation_info.is_suspended && 'elementWithSuspendedObject'
            }`}
            rightContent={isDesktop && tabRightContent}>
            <div label={t('groupHome.tabs.feed')} iconName='feed' onClick={() => handleActiveTab(0, 'feed')}>
              {isGroupOrganizer && <PendingActions groupId={groupId} isMobile={isMobile} />}
              <Feeds
                groupId={groupId}
                isGroupVisible={isPrivateGroup ? isMemberOfGroup : true}
                isMemberOfGroup={isMemberOfGroup}
                isGroupOrganizer={isGroupOrganizer}
                feedIdToScroll={feedIdToScroll}
                setFeedIdToScroll={setFeedIdToScroll}
              />
            </div>
            <div
              label={t('groupHome.tabs.mixrs')}
              iconName='calendar24'
              onClick={() => handleActiveTab(1, 'mixrs')}
              disabled={isPrivateGroup && !isMemberOfGroup}
              badge={stats.mixrs.planned}>
              <Mixrs
                group={group}
                groupId={groupId}
                isMobile={isMobile}
                dateForMixrs={dateForMixrs}
                setDateForMixrs={setDateForMixrs}
              />
            </div>
            <div
              label={t('global.members')}
              onClick={() => handleActiveTab(2, 'members')}
              iconName='groups24'
              disabled={isPrivateGroup && !isMemberOfGroup}>
              <Members groupId={groupId} selectedScope={selectedTabFromUrl === 'leadership' ? 'staff' : ''} />
            </div>
            <div
              label={t('groupHome.tabs.media')}
              onClick={() => handleActiveTab(3, 'media')}
              iconName='picture'
              disabled={isPrivateGroup && !isMemberOfGroup}>
              <Media groupId={groupId} mediaWidgetMoreClicked={mediaWidgetMoreClicked} selectedScope={mediaScope} />
            </div>
            <div
              label={t('groupHome.tabs.info')}
              onClick={() => handleActiveTab(4, 'info')}
              iconName='help'
              disabled={isPrivateGroup && !isMemberOfGroup}>
              <Info groupId={groupId} />
            </div>
          </Tabs>
          <DeleteGroupPopin
            showDeleteGroup={showGroupDeleteModal}
            closeDeleteGroup={() => setShowGroupDeleteModal(false)}
            handleClick={() => dispatch(groupHomeActions.deleteGroup(group.id))}
          />
        </div>
      </div>
      {showSuggestedMixrPopup && (
        <Modal isOpen={showSuggestedMixrPopup} handleClose={closeSuggestedMixrPopup}>
          <CreatedSuggestedMixrPopin closeModal={closeSuggestedMixrPopup} />
        </Modal>
      )}
      {isSuspendModalOpen && (
        <SuspendModal
          isOpen={isSuspendModalOpen}
          hideModal={hideSuspendModal}
          objectType='group'
          objectName={group.name}
          onSuspend={handleSuspend}
        />
      )}
    </PageContainer>
  )
}

export { GroupHomePageContainer }
